window.formatNumber = function (e) {
    let t = e.target.value || "";
    (t = t.replace(/[^0-9 ]/, "")), (e.target.value = t);
}

$(document).ready(function () {
    $("body").hasClass("homepage") && a(),
        $(window).on("resize", function () {
            $("body").hasClass("homepage") && a();
        });
    var e = window.location,
        t = e.protocol + "//" + e.host + "/";

    function i() {
        var e = $(".message-search-wrapper").height(),
            t = $(".chat-name-wrapper").height();
        e > t ? $(".chat-name-wrapper").css("height", e) : $(".message-search-wrapper").css("height", t);
    }

    function s() {
        $(window).width() < 992
        ? ($("#navbarSupportedContent").on("show.bs.collapse", function () {
            $("body:not(.homepage) .navbar").addClass("nav-show").css("min-height", $(window).innerHeight()),
                $("body:not(.homepage) main").css("display", "none"),
                $("body:not(.homepage) footer").css("display", "none"),
                $(".navbar-toggler-icon").addClass("toggle-close");
        }),
            $("#navbarSupportedContent").on("hide.bs.collapse", function () {
                $("body:not(.homepage) .navbar").removeClass("nav-show").css("min-height", "auto"),
                    $("body:not(.homepage) main").css("display", "block"),
                    $("body:not(.homepage) footer").css("display", "block"),
                    $(".navbar-toggler-icon").removeClass("toggle-close");
            }))
        : ($("body:not(.homepage) .navbar").removeClass("nav-show").css("min-height", "auto"),
            $("body:not(.homepage) .navbar-collapse").removeClass("show"),
            $("body:not(.homepage) main").css("display", "block"),
            $("body:not(.homepage) footer").css("display", "block"),
            $(".navbar-toggler-icon").removeClass("toggle-close"));
    }

    function n() {
        if ($(window).width() >= 992) {
            var e = $("html").css("font-size"),
                t = $(".buy-h").outerHeight() - $(".name-h .white-wrapper").innerHeight() - (33 / 16) * parseInt(e);
            $(".info-h").css("margin-top", "-" + t + "px");
        } else $(".info-h").css("margin-top", 0);
    }

    function a() {
        $(window).width() <= 530
        ? ((height = $(".line-wrapper").height() - $(".line-container.last").height() + 19),
            $(".destroy").each(function () {
                $(this).remove();
            }),
            $("body").append('<style class="destroy">.line-wrapper:before{height:' + height + "px}</style>"))
        : ((height = $(".line-wrapper").height() - $(".line-container.last .line-content").height() / 2 - ($(".line-container.last").height() - $(".line-container.last .line-content").height())),
            $(".destroy").each(function () {
                $(this).remove();
            }),
            $("body").append('<style class="destroy">.line-wrapper:before{height:' + height + "px}</style>"));
    }

    s(),
        i(),
        $(".info-wrapper").on("click", function (e) {
            e.stopPropagation(),
                e.preventDefault(),
            $(".info-wrapper").not(this).hasClass("clicked") &&
            ($(".info-wrapper").removeClass("clicked"),
                $(".more-info-wrapper").parents("section").hasClass("messages")
                ? $(".info-wrapper")
                    .find("img")
                    .attr("src", t + "assets/img/messages-info.svg")
                    .parent()
                    .find(".more-info-wrapper")
                    .hide("fast")
                : $(".info-wrapper")
                    .find("img")
                    .addClass("op-5")
                    .attr("src", t + "assets/img/more-info-icon.svg")
                    .parent()
                    .find(".more-info-wrapper")
                    .hide("fast"),
                $("#arrow-style").remove()),
                0 == $(this).hasClass("clicked")
                ? ($(this).addClass("clicked"),
                    $(this).parents("section").hasClass("messages")
                    ? $(this)
                        .find("img")
                        .attr("src", t + "assets/img/messages-info-active.svg")
                        .parent()
                        .find(".more-info-wrapper")
                        .show("fast", function () {
                            var e = $(this).parent().offset().top - $(this).offset().top - $(this).outerHeight();
                            $('<style id="arrow-style">.info-wrapper.clicked:after {top: -' + e + "px}</style>").appendTo("head"),
                            $(this).offset().left < 0 && $(this).css("left", $(this).position().left - $(this).offset().left + 10),
                            $(document).outerWidth() - ($(this).offset().left + $(this).outerWidth()) <= 10 &&
                            $(this).css({
                                            left : "auto",
                                            right: 0,
                                        });
                        })
                    : $(this)
                        .find("img")
                        .removeClass("op-5")
                        .attr("src", t + "assets/img/more-info-icon-active.svg")
                        .parent()
                        .find(".more-info-wrapper")
                        .show("fast", function () {
                            var e = $(this).parent().offset().top - $(this).offset().top - $(this).outerHeight();
                            $('<style id="arrow-style">.info-wrapper.clicked:after {top: -' + e + "px}</style>").appendTo("head"),
                            $(this).offset().left < 0 && $(this).css("left", $(this).position().left - $(this).offset().left + 10),
                            $(document).outerWidth() - ($(this).offset().left + $(this).outerWidth()) <= 10 &&
                            $(this).css({
                                            left : "auto",
                                            right: 0,
                                        });
                        }))
                : ($(this).removeClass("clicked"),
                    $(this).parents("section").hasClass("messages")
                    ? $(this)
                        .find("img")
                        .attr("src", t + "assets/img/messages-info.svg")
                        .parent()
                        .find(".more-info-wrapper")
                        .hide("fast")
                    : $(this)
                        .find("img")
                        .addClass("op-5")
                        .attr("src", t + "assets/img/more-info-icon.svg")
                        .parent()
                        .find(".more-info-wrapper")
                        .hide("fast"),
                    $("#arrow-style").remove()),
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
            ($(this).parent().find("input").prop("checked") ? $(this).parent().find("input").prop("checked", !1) : $(this).parent().find("input").prop("checked", !0));
        }),
        $(document).on("click", function (e) {
            0 === $(e.target).closest(".info-wrapper").length &&
            ($(".info-wrapper").removeClass("clicked"),
                $(".info-wrapper").parents("section").hasClass("messages")
                ? $(".info-wrapper")
                    .find("img")
                    .attr("src", t + "assets/img/messages-info.svg")
                    .parent()
                    .find(".more-info-wrapper")
                    .hide("fast")
                : $(".info-wrapper")
                    .find("img")
                    .addClass("op-5")
                    .attr("src", t + "assets/img/more-info-icon.svg")
                    .parent()
                    .find(".more-info-wrapper")
                    .hide("fast"));
        }),
        $('.notification').on('click', function (e) {
            e.stopImmediatePropagation();
            // if ($(this).find(".notification-wrapper").css('display') == 'block') {
            if ($(this).find(".notification-wrapper").is(':visible')) {
                if (!$(e.target).parents('.notification-wrapper').length) {
                    $(this).find(".notification-wrapper").hide("fast");
                    $(this).find(".notification-backdrop").removeClass('notification-backdrop-visible');
                }
            } else {
                $(this).find(".notification-wrapper").show("fast");
                $(this).find(".notification-backdrop").addClass('notification-backdrop-visible');
            }
        });
    // $("*").on("click", function (e) {
    //     let t = $(e.target);
    //     (t.is(".notification-wrapper") && t.parents(".notification").length) || $(this).find(".notification-wrapper").hide("fast");
    // }),
    $(".buttons-filter button").on("click", function () {
        $(this).parents("ul").find("button").removeClass("active"), $(this).addClass("active");
    }),
        $(".switch-show input").change(function () {
            $(this).prop("checked") ? ($(".hidden-elements").show("fast"), $(".switch-hidden").addClass("d-flex")) : ($(".hidden-elements").hide("fast"), $(".switch-hidden").removeClass("d-flex"));
        }),
        $(".switch-show-trades input").change(function () {
            $(this).prop("checked") ? ($(".trades-hidden").show("fast"), $("html, body").animate({scrollTop: $(".trades-hidden").offset().top}, 500)) : ($(".trades-hidden").hide("fast"), $("html, body").animate({scrollTop: 0}, 500));
        }),
        $(".balance-item .switch input").change(function () {
            $(this).prop("checked")
            ? ($(this).parent().find("#available").hide("fast"), $(this).parent().find("#total").show("fast"), $(".available-column").hide(), $(".total-column").show())
            : ($(this).parent().find("#available").show("fast"), $(this).parent().find("#total").hide("fast"), $(".available-column").show(), $(".total-column").hide());
        }),
        $(".left-filter-menu li").on("click", function () {
            var e = $(this).attr("id");
            $(this).addClass("active").siblings().removeClass("active"), $(this).parents(".left-filter-wrapper").find(".button-search-filter").html(e);
        }),
        $(".left-menu-currency li").on("click", function () {
            $(this).addClass("active").siblings().removeClass("active");
        }),
        $(".circle-wrapper li").on("click", function () {
            var e = $(this).attr("id");
            $(this).addClass("active").siblings().removeClass("active"),
                $("#" + e + "-wrapper")
                    .show("fast")
                    .siblings()
                    .hide("fast");
        }),
        $(".delete-number").on("click", function () {
            $(".phone-number-change").val("").attr("readonly", !1).focus();
        }),
        $(".auto-messages .switch input").change(function () {
            $(this).prop("checked") ? $(this).parents(".auto-messages").find(".white-wrapper").show("fast") : $(this).parents(".auto-messages").find(".white-wrapper").hide("fast");
        }),
        $(".to-open-link").on("click", function () {
            ($this = $(this)), ($parent = $this.parent()), ($toOpen = $parent.find(".to-open")), $this.toggleClass("opened"), $toOpen.slideToggle();
        }),
        $(".faq-link-open").on("click", function () {
            ($this = $(this)), ($parent = $this.parent()), ($toOpen = $parent.find(".to-open")), $this.toggleClass("opened"), $toOpen.slideToggle();
        }),
        $(function () {
            "use strict";
            $(".form-item");

            function e(e) {
                var t = $(e.target).next("input");
                (t && t.length) || (t = $(e.target).parent().find("input").eq(0)), t.focus();
            }

            $(".code-auth .form-item input").on("keyup", function (t) {
                (8 != t.which && 46 != t.which) || ($(this).val(""), $(this).hasClass("first") ? $(this).parent().find(".last").focus() : $(this).prev("input").focus());
                var i = new RegExp("^[0-9]+$"),
                    s = String.fromCharCode(t.charCode ? t.charCode : t.which);
                if (!i.test(s) & !((t.which >= 96) & (t.which <= 105))) return t.preventDefault(), !1;
                (t.which >= 96) & (t.which <= 105) ? (e(t), "" != $(this).val() && $(this).val(String.fromCharCode(t.which - 48))) : (e(t), "" != $(this).val() && $(this).val(String.fromCharCode(t.which)));
            }),
                $(".code-auth input").on("click", "input", function (e) {
                    $(e.target);
                });
        }),
        $(".unhide-icon").on("click", function () {
            var e = $(this).parent().find("input");
            "password" == e.attr("type") ? e.attr("type", "text") : e.attr("type", "password");
        }),
        $(".login-form .grey-input, .login-form .custom-select, .bank-details-item .grey-input, .trades-form-item .grey-input, .trades-form-item .custom-select").on("click", function () {
            $(this).parent().find("label").addClass("focused");
        }),
        $(".login-form .grey-input, .bank-details-item .grey-input, .trades-form-item .grey-input").on("blur", function () {
            "" != $(this).val() ? $(this).addClass("focused").parent().find("label").addClass("focused") : $(this).removeClass("focused").parent().find("label").removeClass("focused");
        }),
        $(".dashboard .dots").on("click", function () {
            let uuid     = $(this).data('uuid');
            let isOpened = $(this).hasClass("open");

            if (isOpened) {
                $(this).removeClass("open");
                $('.balance-actions-menu[data-uuid="' + uuid + '"]').addClass("d-none");
            } else {
                $(this).addClass("open");
                $('.balance-actions-menu[data-uuid="' + uuid + '"]').removeClass("d-none");
            }
        }),
        $(".history-table-item .arrow").on("click", function () {
            $(this).toggleClass("open"),
                $(this).hasClass("open")
                ? ($(this).attr("src", "assets/img/menu-cross-blue.svg"), $(this).parent().find(".number-mobile").slideToggle("fast"))
                : ($(this).attr("src", "assets/img/arrow-grey-select.svg"), $(this).parent().find(".number-mobile").slideToggle("fast"));
        }),
        n(),
        $(window).on("resize", function () {
            $(window).width() > 530
            ? ($(".history-table-item .arrow")
                .removeClass("open")
                .attr("src", t + "assets/img/arrow-grey-select.svg"),
                $(".history-table-item .number-mobile").hide(),
                $(".available-column").show(),
                $(".total-column").show())
            : $(".balance-item .switch input").prop("checked")
              ? ($(".balance-item .switch input").parent().find("#available").hide("fast"), $(".balance-item .switch input").parent().find("#total").show("fast"), $(".available-column").hide(), $(".total-column").show())
              : ($(".balance-item .switch input").parent().find("#available").show("fast"), $(".balance-item .switch input").parent().find("#total").hide("fast"), $(".available-column").show(), $(".total-column").hide()),
            $(window).width() > 991 && ($(".messages-people").show(), $(".chat-wrapper").show(), $(".message-title").removeAttr("style"), $(".message-search-wrapper").removeAttr("style")),
                n(),
                s(),
                i();
        }),
        $(".network-address span").on("click", function () {
            $(this).select();
        }),
        $(".currency-list li").on("click", function () {
            $(this).addClass("active").siblings().removeClass("active");
        }),
        $(".voucher").on("click", function (e) {
            e.preventDefault(), $(this).parent().find("input").slideToggle("fast");
        }),
        $(".trash").on("click", function (e) {
            e.preventDefault(), $(this).parent().find("input").prop("value", ""), $(this).parent().find("label").css("opacity", "0");
        }),
    $("body").hasClass("modal-on-scroll") &&
    $(window).on("scroll", function () {
        "false" === $(".modal-request").attr("displayed") && ($(".modal-request").modal("show"), $(".modal-request").attr("displayed", "true"));
    }),
        $(".request-item.clickable").on("click", function () {
            $(this)
                .find("img")
                .toggleClass("open")
                .attr("src", t + "assets/img/arrow-select-active.svg"),
                $(this).parent().find(".request-item-open").slideToggle("fast"),
                $(this).find("img").hasClass("open")
                ? $(this)
                    .find("img")
                    .attr("src", t + "assets/img/arrow-select-active.svg")
                : $(this)
                    .find("img")
                    .attr("src", t + "assets/img/arrow-grey-select.svg");
        }),
        $(".show-more").on("click", function () {
            $(this).hide().parent().find(".text").css("max-height", "100%").addClass("opened");
        }),
        $(".code-auth input").on("click", function () {
            $(this)
                .parent()
                .bind("paste", function (e) {
                    e.preventDefault();
                    var t = e.originalEvent.clipboardData.getData("text").split("");
                    $(this)
                        .find('input:not([type="hidden"])')
                        .each(function (e, i) {
                            $(i).val(t[e]);
                        });
                });
        }),
        $(".people-item").on("click", function (e) {
            e.preventDefault(),
            $(window).width() < 992 &&
            ($(".message-title").attr("style", "display: none !important"),
                $(this).parents(".messages-people").hide(),
                $(".chat-wrapper").show(),
                $(".messages .chat-window-wrapper").css("height", $(window).outerHeight() - $(".messages .chat-window-wrapper").offset().top - 1 + "px"));
        }),
        $(".lupa-btn-mobile").on("click", function () {
            $(this).parent().attr("style", "display: none !important"), $(".message-search-wrapper").attr("style", "display: flex !important");
        }),
        $(".arrow-chat-back").on("click", function () {
            $(".chat-wrapper").hide(), $(".messages-people").show(), $(".message-title").removeAttr("style");
        }),
        $(".grid-item .grid-item-toggler").on("click", function (e) {
            e.preventDefault(),
                $(this).parent().toggleClass("active-grid").find(".grid-menu").slideToggle("fast", "swing"),
                $(this).parent().hasClass("active-grid")
                ? $(this)
                    .parent()
                    .find(".grid-icon")
                    .attr("src", t + "assets/img/grid-icon-active.svg")
                : $(this)
                    .parent()
                    .find(".grid-icon")
                    .attr("src", t + "assets/img/grid-icon.svg");
        }),
        $(".disable-link-check").on("click", function () {
            $(this).find("input").prop("checked") ? $(this).parent().find(".link-to-disable").removeClass("disable-link") : $(this).parent().find(".link-to-disable").addClass("disable-link");
        }),
        $(".chat-envelope").on("click", function () {
            $("html, body").animate({scrollTop: $(".chat-wrapper").offset().top}, 500);
        }),
        $(".copy-btn").on("click", function () {
            var e = $("<input>");
            $("body").append(e), e.val($(this).parent().find("span").text()).select(), document.execCommand("copy"), e.remove();
        }),
        $(".click .grey-textarea").focusin(function () {
            $(this).parent().find(".textarea-label").toggleClass("focused");
        }),
        $(".click .grey-textarea").focusout(function () {
            $(this).parent().find(".textarea-label").toggleClass("focused");
        }),
        $(".arrow-to-open-img").on("click", function () {
            $(this).toggleClass("rotate").parent().parent().find(".hidden-items").slideToggle("fast");
        }),
        $(".edit-method-btn .edit-show").on("click", function () {
            $(this).parent().find(".edit-btn").toggle().parent().find(".cross").toggle().parent().toggleClass("shown").parent().find(".select-container").slideToggle("fast");
        }),
        $(".add-method-btn .open-add-method").on("click", function () {
            $(".inputs").remove();
            $(this).parent().toggleClass("shown").parent().find(".add-form").toggle().parent().find(".first-select").slideToggle();
        }),
        $(".buy .grey-input").on("click", function () {
            $(this).parent().find("label").addClass("focused");
        }),
        $(".buy .grey-input").on("blur", function () {
            "" != $(this).val() ? $(this).parent().find("label").addClass("focused") : $(this).parent().find("label").removeClass("focused");
        }),
        $(".change").on("click", function () {
            var e = $(".currency-from-select").val();
            $(".currency-from-select").val($(".currency-to-select").val()).trigger("change"), $(".currency-to-select").val(e).trigger("change");
        }),
        $(".shares-item").on("click", ".button-plus", function (e) {
            !(function (e) {
                e.preventDefault();
                var t = $(e.target).data("field"),
                    i = $(e.target).closest("div"),
                    s = parseInt(i.find("input[name=" + t + "]").val(), 10);
                isNaN(s) ? i.find("input[name=" + t + "]").val(0) : i.find("input[name=" + t + "]").val(s + 1);
            })(e);
        }),
        $(".shares-item").on("click", ".button-minus", function (e) {
            !(function (e) {
                e.preventDefault();
                var t = $(e.target).data("field"),
                    i = $(e.target).closest("div"),
                    s = parseInt(i.find("input[name=" + t + "]").val(), 10);
                !isNaN(s) && s > 0 ? i.find("input[name=" + t + "]").val(s - 1) : i.find("input[name=" + t + "]").val(0);
            })(e);
        }),
        $('.bank-item input[type="checkbox"]').on("change", function () {
            $('input[name="' + this.name + '"]')
                .not(this)
                .prop("checked", !1);
        });
});
